import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import "./hm-theme.css";

function LabSettings({ labcode }) {
  const [loader, setLoader] = useState(true);
  const [isAhcEnabled, setIsAhcEnabled] = useState(false);
  const [isPemeEnabled, setIsPemeEnabled] = useState(false);
  const token = JSON.parse(localStorage.getItem("data"))?.token;
  const [labDetails, setLabDetails] = useState(null);

  const navigate = useNavigate();

  const getData = async () => {
    setLoader(true);
    try {
      const response = await axios.get(`/api/labdetails/labcode=${labcode}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLabDetails(response.data);
      setIsAhcEnabled(response.data?.ahc || false);
      setIsPemeEnabled(response.data?.peme || false);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handleToggleChange = async (type, value) => {
    setLoader(true);

    if (type === "ahc") {
      setIsAhcEnabled(value);
    } else if (type === "peme") {
      setIsPemeEnabled(value);
    }

    try {
      const payload = {
        id: labDetails.id,
        ahc: type === "ahc" ? value : isAhcEnabled,
        peme: type === "peme" ? value : isPemeEnabled,
      };

      await axios.post(`/api/labdetails/update`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(`${type.toUpperCase()} status updated successfully!`);
      getData();
    } catch (error) {
      handleError(error);
    } finally {
      setLoader(false);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  useEffect(() => {
    getData();
  }, [labcode]);

  return (
    <div>
      {loader && <div className="loading"></div>}

      <div className="hm-card">
        <div className="hm-card-header">
          <h3 className="hm-card-title">
            <i className="material-icons">settings</i>
            Lab Actions & Settings
          </h3>
        </div>

        <div className="hm-card-body p-4">
          <div className="row g-4">
            {/* AHC Toggle */}
            <div className="col-md-6 col-lg-5">
              <div className="p-3 border rounded bg-light d-flex align-items-center justify-content-between">
                <div>
                  <h6 className="mb-1 fw-semibold text-dark">AHC (Annual Health Check)</h6>
                  <p className="small text-muted mb-0">Enable or disable AHC features for this lab</p>
                </div>
                <div className="form-check form-switch ms-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="ahcToggle"
                    checked={isAhcEnabled}
                    onChange={(e) => handleToggleChange("ahc", e.target.checked)}
                    style={{ cursor: "pointer", width: "2.5em", height: "1.25em" }}
                  />
                </div>
              </div>
            </div>

            {/* PEME Toggle */}
            <div className="col-md-6 col-lg-5">
              <div className="p-3 border rounded bg-light d-flex align-items-center justify-content-between">
                <div>
                  <h6 className="mb-1 fw-semibold text-dark">PEME (Pre-Employment Examination)</h6>
                  <p className="small text-muted mb-0">Enable or disable PEME features for this lab</p>
                </div>
                <div className="form-check form-switch ms-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="pemeToggle"
                    checked={isPemeEnabled}
                    onChange={(e) => handleToggleChange("peme", e.target.checked)}
                    style={{ cursor: "pointer", width: "2.5em", height: "1.25em" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LabSettings;

